import { useMemo, useState } from 'react'
import { ILightRailItem } from '../../../types'
import {
  EmptyDescriptionContainer,
  RailItemDate,
  RailItemDetailsWrap,
  RailItemImage,
  RailItemImageWrap,
  RailItemTitle,
  RailItemWrap,
} from './RailItem.style'
import { ottRoot } from '../../Api'
import { IComponents } from '../../types'
import Link from '../../../components/Link/Link'

export const RailItem = ({
  data,
  isLast,
  isFirst,
  showItemTitle = false,
  timeDuration = false,
}: {
  compName?: IComponents
  data: ILightRailItem
  isLast: boolean
  isFirst: boolean
  showItemTitle?: boolean
  timeDuration?: boolean
}) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  function getImage() {
    const found = data.images.find(e => e.ratio === '16x9')?.url
    if (found) {
      return {
        found: true,
        url: found + '/width/320/height/180/quality/70', //
      }
    }
    return {
      found: false,
      url: 'https://media3.reshet.tv/image/upload/v1709542182/ott/400x400_Logo_Clear_1.webp',
    }
  }

  const [image, setImage] = useState(getImage())
  const href = useMemo(() => {
    let programId
    switch (data.typeDescription) {
      case 'Movie':
        return ottRoot + '/' + data.id
      case 'Trailer':
      case 'Linear':
        return ottRoot + '/' + data.id
      case 'Episode':
        if (data.metas.SeriesID) {
          return (
            ottRoot +
            '/series/' +
            data.metas.SeriesID +
            `/season/${data.metas.SeasonNumber}/` +
            data.id
          )
        } else {
          return ottRoot + '/' + data.id
        }
      case 'Series':
        programId =
          (data.metas?.SeriesID || '') &&
          data.typeDescription === 'Series' &&
          data.id

        if (programId) {
          const { SeriesID } = data.metas || {}
          if (SeriesID && SeriesID) {
            return `${ottRoot}/series/${String(SeriesID)}`
          }
        }
        return `${ottRoot}/${data.externalId}`
    }
    if (data.type === 0) {
      return ottRoot + '/' + data.id
    }
    return '#'
  }, [data.externalId, data.id, data.metas, data.type, data.typeDescription])

  const classList = useMemo(() => {
    if (isFirst) {
      return 'first'
    }
    if (isLast) {
      return 'last'
    }
    return ''
  }, [isFirst, isLast])

  const getTimeDuration = useMemo(() => {
    const startDate = new Date(data.startDate * 1000)
    const updateDate = new Date(data.endDate * 1000)
    const startHours = startDate.getHours().toString().padStart(2, '0')
    const startMinutes = startDate.getMinutes().toString().padStart(2, '0')
    const endHours = updateDate.getHours().toString().padStart(2, '0')
    const endMinutes = updateDate.getMinutes().toString().padStart(2, '0')
    return `${endHours}:${endMinutes} - ${startHours}:${startMinutes}`
  }, [data.endDate, data.startDate])

  return (
    <Link href={href}>
      <RailItemWrap
        className={classList}
        data-type={data.typeDescription}
        data-opc-id={data.id}
      >
        <RailItemImageWrap
          theme={{
            customHeight: '15rem',
            customWidth: '20rem',
            type: 'Trailer',
            customIconWidth: '2rem',
            customIconHeight: '2rem',
            hoverScale: '1.1',
            loaded: imageLoaded,
            found: image.found,
          }}
        >
          <RailItemImage
            src={image.url}
            alt='Image description'
            onLoad={() => setImageLoaded(true)}
            onError={() => {
              setImageLoaded(true)
              setImage({
                ...image,
                url: 'https://media3.reshet.tv/image/upload/v1709542182/ott/400x400_Logo_Clear_1.webp',
              })
            }}
          />
        </RailItemImageWrap>
        <RailItemDetailsWrap
          height={!timeDuration ? 'false' : 'true'}
          theme={{ isCatchup: data.typeDescription === 'catchup' }}
        >
          {showItemTitle && (
            <>
              {timeDuration && <RailItemDate>{getTimeDuration}</RailItemDate>}
              {data.name ? (
                <RailItemTitle>{data.name}</RailItemTitle>
              ) : (
                <EmptyDescriptionContainer />
              )}
              {/*{!timeDuration && data.name && (*/}
              {/*  <RailItemDate>{getDate()}</RailItemDate>*/}
              {/*)}*/}
            </>
          )}
        </RailItemDetailsWrap>
      </RailItemWrap>
    </Link>
  )
}
